import { createContext } from "react";
import { useContext } from "react";

export const  ImageContext= createContext();